import { LoggerFactory } from "../../../logger";
import { isRegExp, merge, pickBy, escapeRegExp, isFunction } from "lodash";

const log = LoggerFactory.create("graph");

export class Node {
  $$data$$: any;
  next: NodeChildren = {};

  public filter(regexOrString?: string | RegExp): NodeChildren {
    log.debug("filter()", regexOrString, this);
    let regex: RegExp;

    if (regexOrString === undefined) {
      regexOrString = "";
    }

    if (!isRegExp(regexOrString)) {
      regexOrString = new RegExp(
        ["^.*", escapeRegExp(regexOrString), ".*$"].join("")
      );
    }

    regex = regexOrString;

    const out = new Node();

    merge(
      out.next,
      pickBy(this.next, (obj: any, key: string) => {
        if (isFunction(obj) || key === "$$data$$" || key === "next") {
          return false;
        }

        return regex.test(key);
      })
    );

    log.debug("filter() =>", out.next);

    return out.next;
  }

  public xpath(seq: string[]): NodeChildren {
    log.debug("xpath()", seq, this);
    const seqLen = seq.length;

    if (seqLen === 0) {
      return this.filter();
    }

    const head = seq.splice(0, 1)[0];

    if (seqLen === 1) {
      return this.filter(head);
    }

    let out;

    try {
      out = this.next[head].xpath(seq);
    } catch (e) {
      out = this.filter();
    }

    return out;
  }

  public getData(): any {
    return this.$$data$$;
  }

  public setData(data: any) {
    this.$$data$$ = data;
  }
}

export class NodeChildren {
  [key: string]: Node;
}
